/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import CPSheetLeaderboardDash from "../../../components/CPSheet/Leaderboard";
import Navbar from "../../../components/Navbar";
import { backendUrlByEnv, LOGIN } from "../../../constants/routes";

const CPSheetLeaderboard = () => {
  const navigate = useNavigate();
  const { config: userConfig, env } = useSelector((state) => state?.reducer?.authInfo) || {};
  const ROOT_URL = backendUrlByEnv(env);
  useEffect(() => {
    if (!userConfig?.cpSheetManagement?.hasLeaderboardManagementAccess) {
      navigate(LOGIN);
    }
  }, []);
  return (
    <>
      <Navbar />
      <CPSheetLeaderboardDash adminConfig={userConfig} ROOT_URL={ROOT_URL} />
    </>
  );
};

export default CPSheetLeaderboard;
